import React, { useState, useEffect } from "react"

import useEventListener from "hooks/useEventListener"
import useScrollBlock from "hooks/useScrollBlock"
import { RiCloseFill } from "react-icons/ri"

import "./Modal.scss"

export default function Modal({
    isOpen,
    close,
    escToClose = true,
    clickOutsideToClose = true,
    hasBorderRadius = true,
    hasAnimatedClose = true,
    closeConfirm = "",
    hasCloseButton = true,
    children
}){
    const [isModalDisplayed, setIsModalDisplayed] = useState(true)

    useScrollBlock(isOpen)

    useEffect(() => {
        if (isOpen){
            setIsModalDisplayed(isOpen)
        }
    }, [isOpen])

    const handleClose = () => {
        // eslint-disable-next-line no-alert
        if (closeConfirm && !confirm(closeConfirm)){
            return
        }
        setIsModalDisplayed(false)

        setTimeout(() => {
            close()
            setIsModalDisplayed(true)
        }, 167)
    }

    useEventListener("keydown", (event) => {
        if (event.keyCode !== 27 || !escToClose){
            return
        }

        handleClose()
    })

    if (!isOpen){
        return <></>
    }

    return (
        <section>
            <div
                className={ `z-9 fixed left-0 top-0 bg-secondary opacity-90  w-full h-full` }
                role="button"
                tabIndex="0"
                onClick={ clickOutsideToClose ? handleClose : undefined }
                onKeyPress={ null }
            />

            <div
                className={ `z-9 bg-tertiary top-1/2 left-1/2 max-w-screen ${
                    hasBorderRadius ? "rounded-lg" : ""
                }  fixed max-h-full overflow-hidden transform -translate-x-1/2 -translate-y-1/2 ${
                    hasAnimatedClose ? "animationShowPopup" : ""
                } ${!isModalDisplayed && hasAnimatedClose ? "animationHidePopup" : ""}` }
            >
                { children }

                { hasCloseButton && (
                    <div
                        className="top-2 z-9 right-2 laptop:right-5 text-tertiary tablet:p-2 bg-primary hover:bg-primary--light absolute inline-block p-1 rounded-full cursor-pointer"
                        role="button"
                        tabIndex="0"
                        onClick={ handleClose }
                        onKeyPress={ null }
                    >
                        <RiCloseFill fill={ "#fff" } size={ 24 } />
                    </div>
                ) }
            </div>
        </section>
    )
}
